<template>
  <div class="mit-keys-list"><!-- default all to 1 but override sm and larger to 8 -->
    <MitKeyEditor :show="editDialogShow" :title="editKeyTitle" :keyModel="editKey" :existingKeyNames="existingKeyNames" :spacesModel="spaces" v-on:save="editSave" v-on:cancel="editClose"/>
    <v-dialog v-model="removeDialogShow" max-width="500px">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="removeClose">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="removeConfirmed">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pa-3" elevation="0">
        <v-btn @click="create()" small class="mb-5 showOnMobile doNotPrint">
           New Key
          <v-icon class="pl-2">mdi-key</v-icon>
        </v-btn>
        <v-card-title>
        <span class="elevation-0 hideOnMobile">
          Keys
        </span>
        <v-spacer class="hideOnMobile"></v-spacer>
          <v-text-field
            class="search-text doNotPrint"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <v-btn @click="create()" class="ml-5 hideOnMobile doNotPrint">
            New Key
            <v-icon class="pl-2">mdi-key</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Browser view -->
        <v-data-table
          class="elevation-0 hideOnMobile doNotPrint"
          :headers="headers"
          :items="keys"
          :search="search"
          :items-per-page="-1"
        >
          <template v-slot:item.data.notes="{ item }">
            <v-tooltip top v-if='item.data.notes != ""' max-width="400" color="#333" offset-overflow style="opacity: 1!important;" >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-text-box-outline</v-icon>
              </template>
              <span>{{item.data.notes}}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.spacesDisplay="{ item }">
            <MitKeySpaces :search="{text:search}" :spaces="item.spacesDisplay" :spacesDetails="item.spaces" />
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="edit(item)">mdi-pencil</v-icon>
            <v-icon small @click="remove(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>

        <!-- Mobile View -->
        <v-data-table
          class="elevation-0 showOnMobile doNotPrint"
          :headers="headersMobile"
          :items="keys"
          item-key="name"
          :items-per-page="-1"
          show-expand
          :search="search"
        >
          <template v-slot:expanded-item="{ item }">
            <td :colspan="headersMobile.length" style="border:0">
              Spaces:<MitKeySpaces size="small" :dark="false" :search="{text:search}" :spaces="item.spacesDisplay" :spacesDetails="item.spaces"/><br/>
              Type:  {{ item.type.name }}<br/>
              Total Number of Keys: {{ item.count }}<br/>
              Available Keys: {{ item.numberAvailable }}<br/>
              Notes: {{ item.data.notes }}<br/>
              Last updated: {{ item.dates_local.lastEditedDate }}

              <p><v-btn icon  small style="float:right;" color="error" @click="remove(item)"><v-icon>mdi-delete</v-icon></v-btn>
              <v-btn  icon color="#666" small style="float:right; margin-right:20px;"  @click="edit(item)"><v-icon>mdi-pencil</v-icon></v-btn></p>
            </td>
          </template>
        </v-data-table>

        <!-- Print view -->
        <v-data-table
          class="elevation-0 hideOnMobile printMe"
          :headers="headers"
          :items="keys"
          :items-per-page="-1"
        >
          <template v-slot:item.spacesDisplay="{ item }">
            <span v-for="(space, i) in item.spacesDisplay" :key="i">
              {{ space }},
            </span>
          </template>
        </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import MitKeysService from '../services/MitKeysService.js';
import MitSpacesService from '../services/MitSpacesService.js';
import MitKeyEditor from './MitKeyEditor.vue';
import MitKeySpaces from './keys/MitKeySpaces.vue';

export default {
  name: 'MitKeysList',
  components: {
    MitKeyEditor,
    MitKeySpaces
  },
  props: {},
  data: function() {
    return {
      search: '',
      dialog: {},
      headers:[
        {text: 'Name',align: 'start',sortable: true,value: 'name', width: '10%', filterable:true},
        //{text: 'Type',sortable: true,value: 'type.name', width: '12%', filterable:false},
        {text: 'Total',sortable: true,value: 'count', width: '7%', filterable:false},
        {text: 'Available',sortable: true,value: 'numberAvailable', width: '10%', filterable:false},
        {text: 'Spaces',sortable: true,value: 'spacesDisplay', filterable:true},
        {text: 'Last Updated', sortable: true, value: 'dates_local.lastEditedDate', width: '12%', filterable:false, class: 'doNotPrint', cellClass:'doNotPrint', sort: function(a,b){
             return moment.utc(a).diff(moment.utc(b))
        }},
        {text: 'Notes', sortable: false, value: 'data.notes', filterable:true},
        {text: 'Actions', value: 'actions', sortable: false, width: '5%', filterable:false, class: 'doNotPrint', cellClass:'doNotPrint' }
      ],
      headersMobile:[
        {text: 'Name',align: 'start',sortable: true,value: 'name', filterable:true},
          // {text: 'Spaces',sortable: true,value: 'accessSpacesDisplay',filterable:true}
      ],
      keys:[],
      editDialogShow:false,
      editKey:null,
      existingKeyNames:[],
      editKeyTitle:'New Key',
      removeDialogShow:false,
      removeKey:null,
      spaces:[]
    }
  },
  mounted() {
    this.refresh();
    this.spacesRefresh();
  },
  methods : {
    refresh() {
      MitKeysService.requestGetKeys()
        .then((data) => {
          this.keys = data;
        })
        .catch((error) => {
          console.log('An error occurred trying to get keys list', error);
        });
    },
    spacesRefresh() {
      MitSpacesService.getBuildingSpacesList('building,floor,space')
        .then((data) => {
          let spacesList = [];
          let buildingId = data.spaces[0].buildingMitId;
          for(let x = 0; x < data.spaces.length; x++){
              if(data.spaces[x].spaceType === 'floor'){
                  spacesList.push({ divider: true});
                  spacesList.push({ header: 'Floor '+ data.spaces[x].level});
                  spacesList.push({ divider: true});
              }
              else{
                  spacesList.push({
                    mitId:data.spaces[x].mitId,
                    mitIdShort:data.spaces[x].mitIdShort,
                    name:data.spaces[x].name,
                    type:data.spaces[x].spaceType,
                    org:data.spaces[x].org,
                    level:data.spaces[x].level,
                    group:'Floor '+data.spaces[x].level,
                    building:data.spaces[x].buildingMitId
                  });
              }

          }
          this.spaces = spacesList;
        })
        .catch((error) => {
          console.log('An error occurred trying to get keys list', error);
        });
    },
    gatherExistingKeyNames(exclude){
      this.existingKeyNames = [];

      for( let k in this.keys){
        //Exclude the name of a key we are editing so validation doesn't
        if(this.keys[k].name !== exclude)
          this.existingKeyNames.push(this.keys[k].name.toUpperCase());
      }
    },
    create() {
      this.gatherExistingKeyNames();
      this.editKeyTitle = 'New Key';
      this.editKey = MitKeysService.getNewKey();;
      this.editDialogShow = true;
    },
    edit(item) {
      this.gatherExistingKeyNames(item.name);
      this.editKeyTitle = 'Edit Key';
      this.editKey = item;
      this.editDialogShow = true;
    },
    editSave(item) {
      this.editClose();
      console.log('SAVED: ', item);
      MitKeysService.requestSaveKey(item)
        .then((data) => {
          return this.refresh();
        })
        .catch((error) => {
          console.log('An error occurred trying to get keys list', error);
        });
    },
    editClose() {
      this.editDialogShow = false;
      this.editKey = null;
    },
    remove (item) {
      this.removeItem = item;
      this.removeDialogShow = true;
    },
    removeConfirmed () {
      this.removeDialogShow = false;

      MitKeysService.requestDeleteKey(this.removeItem.name)
        .then((data) => {
          this.removeItem = null;
          return this.refresh();
        })
        .catch((error) => {
          this.removeItem = null;
          console.log('An error occurred trying to delete key: '+this.removeItem.name, error);
        });
    },
    removeClose () {
      this.removeDialogShow = false;
      this.removeItem = null;
    }
  }
}
</script>

<style lang="scss" scoped>
  @media only screen and (max-width: 599px){
    .hideOnMobile, .hide {
      display: none;
    }
    .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
      box-shadow: none;
    }
    td {
      display: block;
    }
  }
  @media only screen and (min-width: 599px){
    .showOnMobile {
      display:none
    }
  }
</style>
